/**
 * Created by hoaiphuong.nguyen on 3/21/2017.
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: '[progressbar]',
    templateUrl: './progressbar.component.html',
    styleUrls: ['./progressbar.component.scss']
})
export class ProgressbarComponent {
    @Input() percentage: number;
    @Input() tooltip: string;
}